export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-foreground-300">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="text-lg font-heading font-bold text-white mb-3">91影视看片下载</div>
            <p className="text-xs md:text-sm leading-relaxed text-foreground-300">
              专业的在线影视视频播放平台，提供麻豆影视在线观看、高清电影电视剧全集免费在线播放。即点即播无需下载，流畅不缓冲，每日更新热门影视资源。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white mb-3">快速导航</h3>
            <div className="flex flex-col gap-2">
              <a href="#hero" className="text-xs md:text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap">首页</a>
              <a href="#cards" className="text-xs md:text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap">热门推荐</a>
              <a href="#index" className="text-xs md:text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap">专题索引</a>
              <a href="#faq" className="text-xs md:text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap">常见问题</a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white mb-3">内容分类</h3>
            <div className="flex flex-col gap-2">
              <a href="#cards" className="text-xs md:text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap">华语电影</a>
              <a href="#cards" className="text-xs md:text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap">韩国电影</a>
              <a href="#cards" className="text-xs md:text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap">日本电视剧</a>
              <a href="#cards" className="text-xs md:text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap">好莱坞大片</a>
              <a href="#cards" className="text-xs md:text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap">动漫番剧</a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white mb-3">联系我们</h3>
            <div className="flex flex-col gap-2">
              <a href="#contact" className="text-xs md:text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap">投稿合作</a>
              <a href="#contact" className="text-xs md:text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap">意见反馈</a>
              <a href="#app" className="text-xs md:text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap">APP下载</a>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-foreground-800">
          <div className="mb-4">
            <h3 className="text-xs font-semibold text-foreground-400 mb-2">合作伙伴</h3>
            <p className="text-xs text-foreground-500">—— 合作品牌即将揭晓 ——</p>
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} 91影视看片下载 - 在线看电影电视剧全集免费不缓冲
            </p>
            <div className="flex items-center gap-4">
              <a href="#contact" className="text-xs text-foreground-400 hover:text-white transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#contact" className="text-xs text-foreground-400 hover:text-white transition-colors whitespace-nowrap">服务条款</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}